import store from "@/store/store.js"
import Vue from '@/main'
import { getCurrentTenant } from '@/utils'
import ticketTransfer from "@/http/requests/ticketTransfer"

export default {
    fetch({ commit }) {
      return new Promise((resolve, reject) => {
        ticketTransfer.fetch().then(response => {
          commit('SET_TICKET_TRANSFER', response.data.data.ticketTransfer)
          resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  add({ commit }, { nextUserId, previousUserId, chatTicketId }) {
    return new Promise((resolve, reject) => {
      ticketTransfer.add(nextUserId, previousUserId, chatTicketId).then(response => {
        commit('ADD_TICKET_TRANSFER', response.data.data.createTicketTransfer)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  confirmTicketTransfer(_, ticketTransferId) {
    return new Promise((resolve, reject) => {
      ticketTransfer.confirmTicketTransfer(ticketTransferId).then(response => {
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  deleteTicketTransfer(_, ticketTransferId) {
    return new Promise((resolve, reject) => {
      ticketTransfer.deleteTicketTransfer(ticketTransferId).then(response => {
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  clearNotifications({commit}) {
    commit('CLEAR_NOTIFICATION_TRANSFER')
  },
  clearNotificationById({commit}, id) {
    commit('CLEAR_NOTIFICATION_TRANSFER_BY_ID', id)
  },
  socketListeners({commit}) {
    Vue.$events.on('ChatTicketTransferred', ({
      chatTicket,
      triggerUserId,
      triggerUserName,
      instanceName,
      tenantName
    }) => {
      const { AppActiveUser } = store.state

      if ( tenantName === getCurrentTenant() && AppActiveUser.id !== triggerUserId ) {
        let dialogText = ''
        let dialogTitle = ''

        if (AppActiveUser.id === chatTicket.user_id) {
          // New attendant
          dialogTitle = 'Atendimento Recebido'

          if (triggerUserId === null) {
            // Automatically redirected
            if ( chatTicket.previous_user_id ) {
              dialogText = `O atendimento do(a) cliente ${chatTicket.customer_name} (${chatTicket.protocol})`
              dialogText += ` pertencente ao usuário ${chatTicket.previous_user_name}`
              dialogText += ` foi transferido para você devido a Mudança de Departamento ou Interação do Bot Passivo no atendimento!`
              dialogText += `\n\nAtendimento da conexão: ${instanceName}`
            }
          } else {
            // Manually redirected
            dialogText = `O atendimento do(a) cliente ${chatTicket.customer_name} (${chatTicket.protocol})`
            dialogText += ` que pertencia ao usuário ${chatTicket.previous_user_name}`
            dialogText += ` foi transferido pelo usuário ${triggerUserName} diretamente para você!`
            dialogText += `\n\nAtendimento da conexão: ${instanceName}`
          }
        } else if (AppActiveUser.id === chatTicket.previous_user_id || AppActiveUser.id === 1) {
          // Previous attendant OR Administrator
          dialogTitle = 'Atendimento Transferido'

          if (triggerUserId === null) {
            // Automatically redirected
            if ( chatTicket.previous_user_id) {
              dialogText = `O atendimento do(a) cliente ${chatTicket.customer_name} (${chatTicket.protocol})`
              dialogText += ` foi transferido devido a Mudança de Departamento ou Interação do Bot Passivo no atendimento!`
              dialogText += `\n\nAtendimento da conexão: ${instanceName}`
            }
          } else {
            // Manually redirected
            dialogText = `O atendimento do(a) cliente ${chatTicket.customer_name} (${chatTicket.protocol})`
            dialogText += ` foi transferido pelo usuário ${triggerUserName} para outro atendente!`
            dialogText += `\n\nAtendimento da conexão: ${instanceName}`
          }
        }

        return new Promise((resolve) => {
          if (!dialogText) {
            return
          }

          commit('ADD_NOTIFICATION_TRANSFER', {
            id: chatTicket.id,
            title: dialogTitle,
            text: dialogText
          })

          resolve()
        })
      }
    });
  }
}
